/**
 * @generated SignedSource<<711125e6dab30160a28ed6b573091707>>
 * @relayHash 9ce2f3b6041d9811aa0610eb4ed7bdf8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 613b2432aea0ccf8836e766a30891080990150ccac329e8c0341828e94eb1455

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CsmAppSidebarContentQuery } from './CsmAppSidebarContentQuery.graphql';

import isAllowingEndUsersToAccessCustomTemplates_provider from '@jira/platform__graphql-relay-provider/src/jira-custom-template-allow-end-users-to-create-custom-templates.relayprovider';
import checkForA11YEnabledFF_provider from '@jira/platform__graphql-relay-provider/src/jsm-aiiy-for-nav-item-sidebar.relayprovider';

const node: PreloadableConcreteRequest<CsmAppSidebarContentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "613b2432aea0ccf8836e766a30891080990150ccac329e8c0341828e94eb1455",
    "metadata": {},
    "name": "CsmAppSidebarContentQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": isAllowingEndUsersToAccessCustomTemplates_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjsmaiiyfornavitemsidebarrelayprovider": checkForA11YEnabledFF_provider
    }
  }
};

export default node;
